// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__iw2hp","main":"Layout_main__sRe3U"};